import { LogoutOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useContext, useEffect } from "react";
import { Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserWrapper";
import { getParams } from "../../../utils/common";
import { isValidSession, logout } from "../../../utils/sessionStorage";

const Layout = ({ renderProp }) => {
  const token = getParams().token;
  const nav = useNavigate();

  const { store } = useContext(UserContext);

  const handleLogout = () => logout();

  useEffect(() => {
    if (!isValidSession() && !token) nav("/login");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isValidSession()) return null;

  return (
    <nav className='navbar d-flex justify-content-around flex-wrap p-2 gap-1'>
      <img
        alt='Logo Neuquen Capital'
        height='80%'
        src='https://webservice.muninqn.gov.ar/cglobales/assets/banners/neuquen-2024.svg'
      />

      <div className='d-flex align-items-center gap-sm-2'>
        <img alt='imágen perfil' className='imagen-usuario-navbar' src={store?.data?.imagenUrl} />

        <div className='d-none d-sm-block text-start'>
          <small className='nombre-usuario-navbar'>{store?.data?.nombre}</small>
          <br />
          <small className='email-usuario-navbar'>{store?.data?.correoElectronico}</small>
        </div>

        <div className='vr d-none d-sm-block'></div>

        <div className='ms-2 ms-sm-none text-primary' onClick={handleLogout} role='button'>
          <i className='fa-solid fa-arrow-right-from-bracket me-2'></i>
          Salir
        </div>
      </div>
    </nav>
  );
};

export default Layout;
